import { render, staticRenderFns } from "./wa-footer.vue?vue&type=template&id=9d99a522&scoped=true&"
import script from "./wa-footer.vue?vue&type=script&lang=js&"
export * from "./wa-footer.vue?vue&type=script&lang=js&"
import style0 from "./wa-footer.vue?vue&type=style&index=0&id=9d99a522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d99a522",
  null
  
)

export default component.exports